<template>
  <div class="component-account-overview-card">
    <div class="flex items-center bm-size-[14px] leading-5">
      <span>{{ $t('bmui-navigator-bar.common_account_total_balance') }}</span>

      <svg
        v-show="showPrivate"
        class="svgfont bm-size-4 ml-[6px] cursor-pointer"
        @click="onChangeAssetsVisiblity"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          d="M258.385 168.22c-48.48 0-87.781 39.3-87.781 87.78s39.3 87.781 87.781 87.781c48.481 0 87.781-39.3 87.781-87.781 0-48.48-39.3-87.781-87.781-87.781zM199.864 256c0-32.32 26.201-58.52 58.52-58.52 32.321 0 58.52 26.201 58.52 58.52 0 32.321-26.199 58.52-58.52 58.52-32.32 0-58.52-26.199-58.52-58.52z"
        />
        <path
          d="M256 95.069c-104.401 0-193.744 64.321-230.627 155.441l-2.223 5.489 2.223 5.489c36.885 91.122 126.227 155.441 230.627 155.441s193.744-64.32 230.626-155.442l2.224-5.489-2.224-5.489c-36.882-91.12-126.226-155.441-230.626-155.441zM256 387.671c-89.966 0-167.321-54.14-201.196-131.671 33.875-77.529 111.23-131.671 201.196-131.671s167.318 54.142 201.196 131.671c-33.877 77.531-111.23 131.671-201.196 131.671z"
        />
      </svg>
      <svg
        v-show="!showPrivate"
        class="svgfont bm-size-4 ml-[6px] cursor-pointer"
        @click="onChangeAssetsVisiblity"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          d="M56.249 62.547c5.812-5.811 15.234-5.811 21.045 0l52.767 52.767c37.081-21.328 80.081-33.528 125.939-33.528 106.191 0 197.067 65.424 234.581 158.107l2.262 5.584-2.262 5.583c-20.536 50.736-57.060 93.301-103.334 121.44l55.908 55.908c5.813 5.81 5.813 15.232 0 21.045-5.813 5.81-15.235 5.81-21.045 0l-62.438-62.438-0.512 0.232-22.759-22.759 0.536-0.208-210.97-210.97-0.433 0.312-21.285-21.285 0.425-0.319-48.427-48.427c-5.811-5.811-5.811-15.233 0-21.045zM207.458 192.71c1.161-1.305 2.368-2.584 3.619-3.835 34.87-34.868 91.399-34.868 126.269 0s34.869 91.403 0 126.269c-1.25 1.253-2.53 2.458-3.837 3.62l31.988 31.988c42.065-23.724 75.673-60.7 95.149-105.273-34.459-78.859-113.137-133.929-204.646-133.929-37.563 0-72.964 9.279-104.031 25.673l55.489 55.489zM228.557 213.81l83.854 83.854c1.337-1.122 2.634-2.31 3.89-3.565 23.247-23.244 23.247-60.934 0-84.179-23.244-23.246-60.935-23.246-84.179 0-1.256 1.256-2.445 2.554-3.565 3.89z"
        />
        <path
          d="M70.999 162.22c-20.956 22.46-37.87 48.739-49.581 77.674l-2.261 5.584 2.26 5.583c37.517 92.684 128.392 158.107 234.583 158.107 19.166 0 37.834-2.131 55.777-6.17l-25.613-25.613c-9.866 1.334-19.935 2.021-30.163 2.021-91.51 0-170.19-55.069-204.646-133.928 10.059-23.021 23.886-44.014 40.701-62.202l-21.055-21.055z"
        />
      </svg>
    </div>
    <div class="bm-size-5 leading-7 font-medium">{{ showPrivate ? $numbro(datas.sumAssetsBtc) : '********' }} BTC</div>
    <div class="bm-size-[14px] leading-5">
      ≈{{ showPrivate ? $numbro(datas.sumAssetsLocal) : '********' }} {{ datas.currencySymbol }}
    </div>

    <div class="flex my-4 bm-row bm-gx-2" v-if="!isSubAccount">
      <SensorTrack
        class="bm-col box-border"
        :datas="[
          {
            sensorEventName: 'ClickDeposit',
            current_page: '我的（菜单）',
            crypto_currency: '数字货币列表',
          },
          {
            sensorEventName: 'ClickTopBar',
            module_name: '我的',
            button_name: '我的（充值）',
          },
        ]"
      >
        <nuxt-link-enhance
          class="flex justify-center items-center rounded-sm cursor-pointer bm-size-3 leading-4 px-6 py-2 border border-solid whitespace-nowrap bm-bd-gray-200 actived bm-bg-effect bm-text-white bm-bd-effect hover:bm-bg-effect-300 hover:bm-bd-effect-300"
          project="www"
          to="/asset-deposit"
        >
          {{ $t('bmui-navigator-bar.common_account_btn_deposit') }}
        </nuxt-link-enhance>
      </SensorTrack>
      <SensorTrack
        class="bm-col box-border"
        :datas="[
          {
            sensorEventName: 'ClickDeposit',
            current_page: '我的（菜单）',
            crypto_currency: '数字货币列表',
          },
          {
            sensorEventName: 'ClickTopBar',
            module_name: '我的',
            button_name: '我的（提现）',
          },
        ]"
      >
        <nuxt-link-enhance
          class="bm-col box-border flex justify-center items-center rounded-sm cursor-pointer bm-size-3 leading-4 px-6 py-2 border border-solid whitespace-nowrap bm-bd-gray-400 hover:bm-bd-effect hover:bm-text-effect"
          project="www"
          to="/asset-withdrawal"
        >
          {{ $t('bmui-navigator-bar.common_account_btn_withdrawal') }}
        </nuxt-link-enhance>
      </SensorTrack>
    </div>
    <div class="flex justify-between items-center" v-if="!isSubAccount">
      <span class="bm-size-3 leading-4">{{ $t('bmui-navigator-bar.common_account_bmx_discount') }}</span>
      <SensorTrack
        :datas="{
          sensorEventName: 'ClickTopBar',
          module_name: '我的',
          button_name: '我的（BMX抵扣）',
        }"
      >
        <el-switch
          class="ml-2"
          :width="36"
          :value="isUserFeeDeducted"
          v-loading="isUseBMXDiscountLoading"
          @change="onSwitchUseBMXDiscount($event)"
        />
      </SensorTrack>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import commonMixins from '../mixins';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import SensorTrack from './SensorTrack';
import { axiosClient } from '~/common/js/axios';
import { insertSignToParams } from '~/common/js/utils';
import { usePatchStore } from '~/common/js/patch';
export default {
  name: 'ComponentAccountOverviewCard',
  components: {
    SensorTrack,
    NuxtLinkEnhance,
  },
  props: {
    datas: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mixins: [commonMixins],

  computed: {
    locale() {
      return this.store.locale;
    },
    isUserFeeDeducted() {
      return !!this.store.account?.isUserFeeDeducted;
    },
    isSubAccount() {
      return this.store.getters['account/isSubAccount'];
    }
    // ...mapGetters({
    //   // 是否子账户
    //   isSubAccount: 'account/isSubAccount',
    // }),

  },
  data() {
    return {
      isUseBMXDiscountLoading: false,
      showPrivate: false,
    };
  },
  methods: {
    onChangeAssetsVisiblity() {
      this.showPrivate = !this.showPrivate;
      window.localStorage.setItem('showPrivate', this.showPrivate);
    },
    onSwitchUseBMXDiscount(val) {
      // console.log('onSwitchUseBMXDiscount===',val);
      this.isUseBMXDiscountLoading = true;

      // const token = Cookies.get('accessToken');
      const salt = Cookies.get('accessSalt');
      const params = {
        deduction: val ? 1 : 0,
        timestamp: new Date().getTime(),
      };

      insertSignToParams(params, params.timestamp, salt);

      axiosClient({
        method: 'POST',
        url: '/gw-api/spot-fee/user/updateDecuction',
        data: params,
        // headers: {
        //   Authorization: token,
        // },
      })
        .then((res) => {
          if (res?.success) {
            this.store.commit('account/SET_USER_FEE_DEDUCTION', val);
          }
        })
        .finally(() => {
          this.isUseBMXDiscountLoading = false;
        });
    },
  },
  mounted() {
    // 初始赋值
    this.showPrivate = window.localStorage.getItem('showPrivate') === 'true';

    if (this.isUserFeeDeducted === null) {
      this.store.dispatch('account/getUserFeeDeduction');
    }

    // @TODO 这里需要再确认下什么作用
    if (!this.feeLevel) {
      this.store.dispatch('account/getUserTradeLevelInfo');
    }
  },
  setup() {
    const { store } = usePatchStore();
    return {
      store,
    };
  }
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-account-overview-card {
}
</style>
